import { render, staticRenderFns } from "./DefaultAside.vue?vue&type=template&id=97c30444&scoped=true&"
import script from "./DefaultAside.vue?vue&type=script&lang=js&"
export * from "./DefaultAside.vue?vue&type=script&lang=js&"
import style0 from "./DefaultAside.vue?vue&type=style&index=0&id=97c30444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c30444",
  null
  
)

export default component.exports